import {checkJson} from "./checkJson";

export function getOptionsFromJsonString(jsonString = "", defaultOptions = {}) {
    let options = {};

    if (jsonString !== "") {
        const jsonOption = checkJson(jsonString);
        if (jsonOption !== false) {
            options = jsonOption;
        }
    }

    options = {...defaultOptions, ...options};

    return options;
}